<template>
  <div class="console-container">
    <el-container class="console-layout">
      <!-- 左侧导航栏 -->
      <el-aside width="220px" class="console-sidebar">

        <el-menu
            :default-active="activeMenu"
            class="console-menu"
            router
        >
          <el-menu-item v-if="userRole === 'SUPERADMIN'" index="/console/admindashboard" >
            <el-icon><Histogram /></el-icon>
            <span>性能监控</span>
          </el-menu-item>

          <el-menu-item v-if="userRole === 'SUPERADMIN'" index="/console/usermanage" >
            <el-icon><User /></el-icon>
            <span>用户管理</span>
          </el-menu-item>

          <el-menu-item v-if="userRole === 'SUPERADMIN'" index="/console/profile" >
            <el-icon><User /></el-icon>
            <span>个人中心</span>
          </el-menu-item>

          <el-menu-item index="/console/pluginmanage">
            <el-icon><Link /></el-icon>
            <span>插件管理</span>
          </el-menu-item>

          <el-menu-item index="/console/ordermanage">
            <el-icon><List /></el-icon>
            <span>订单管理</span>
          </el-menu-item>

          <el-sub-menu v-if="userRole === 'SUPERADMIN'" index="/console/system">
            <template #title>
              <el-icon class="custom_icon"><Tools /></el-icon>
              <span>系统管理</span>
            </template>

            <!-- 子菜单项 -->
            <el-menu-item index="/console/system/settings">
              <el-icon><Setting /></el-icon>
              <span>系统设置</span>
            </el-menu-item>

            <el-menu-item index="/console/system/accesslog">
              <el-icon><List /></el-icon>
              <span>访问日志</span>
            </el-menu-item>
          </el-sub-menu>

        </el-menu>

      </el-aside>

      <!-- 右侧内容区域 -->
      <el-container class="console-main-container">
        <el-main class="console-main">

          <div class="main-content">
            <router-view />
          </div>
        </el-main>
      </el-container>
    </el-container>

  </div>
</template>

<script>
import { useRoute, useRouter } from 'vue-router'
import { ref, watch, computed, onMounted, nextTick } from 'vue'
import request from '@/utils/request'
import { getCurrentUserRole } from '@/utils/auth'
import {
  User, Link, List, Grid, Folder, Setting, Tools,
  Refresh, Plus
} from '@element-plus/icons-vue'


export default {
  name: 'Console',
  components: {
    User,
    Link,
    List,
    Grid,
    Folder,
    Setting,
    Tools,
    Refresh,
    Plus
  },

  setup() {
    const route = useRoute()
    const router = useRouter()
    const activeMenu = ref('')
    const userRole = ref('')

    const routeNameMap = {
      '': '用户管理',
      // 其他路由映射
    }

    const currentRouteName = computed(() => {
      return routeNameMap[route.path] || '控制台'
    })

    // 获取当前用户角色
    const fetchCurrentRole = async () => {
      try {
        userRole.value = await getCurrentUserRole()
        console.log('Console 用户角色:', userRole.value)

        // 确保菜单更新后重新计算激活状态
        await nextTick()
        activeMenu.value = route.path

        // 如果当前路径是控制台根路径，重定向到第一个菜单
        if (route.path === '/console') {
          redirectToFirstMenu()
        }
      } catch (error) {
        console.error('获取用户角色错误:', error)
      }
    }

    // 重定向到第一个可用的菜单
    const redirectToFirstMenu = () => {
      // 根据用户角色确定第一个菜单
      let firstMenuPath = '/console/pluginmanage' // 默认第一个菜单

      if (userRole.value === 'SUPERADMIN') {
        firstMenuPath = '/console/usermanage'
      }

      // 执行重定向
      router.replace(firstMenuPath)
      activeMenu.value = firstMenuPath
    }

    // 监听路由变化，设置激活菜单
    watch(() => route.path, (newPath) => {
      activeMenu.value = newPath
    }, { immediate: true })

    onMounted(() => {
      fetchCurrentRole()
    })

    return {
      activeMenu,
      userRole,
      currentRouteName
    }
  }
}
</script>

<style scoped>
.console-container {
  display: flex;

  flex: 1;
  background-color: #f5f7fa;
}

.console-layout {

}

.console-sidebar {
  background: linear-gradient(90deg, #fefdfd 0%, #f8fafe 100%);
  color: #01030b;
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: all 0.3s;
  box-shadow: 2px 0 6px rgba(0, 0, 0, 0.05); /* 更柔和的阴影 */
  z-index: 1;
  border-right: 1px solid #eaeef2;
}

.console-menu {
  border-right: none;
  flex: 1;
  background: transparent;
}

.console-menu :deep(.el-menu-item),
.console-menu :deep(.el-sub-menu__title) {
  height: 40px;
  line-height: 40px;
  margin: 5px 0;
  transition: all 0.2s;
  color: #606266;
  font-size: 14px;
  font-weight: 500;
}

.console-menu :deep(.el-menu-item:hover),
.console-menu :deep(.el-sub-menu__title:hover) {
  background-color: #d4cfcf;
  color: #303133;
}

.console-menu :deep(.el-menu-item.is-active),
.console-menu :deep(.el-sub-menu__title.is-active) {
  background-color: #ecf5ff;
  color: #409eff;
  font-weight: 500;
  border-right: 3px solid #409eff;
  box-shadow: none;
}

.console-menu ::v-deep(.el-menu-item) .el-icon,
.console-menu :deep(.el-sub-menu__title) .el-icon {
  color: #909399;
  font-size: 18px;
  margin-right: 10px;
}

.console-menu :deep(.el-menu-item.is-active) .el-icon {
  color: #409eff; /* 激活图标颜色 */
}

/* 子菜单背景颜色 */
.console-menu :deep(.el-sub-menu .el-menu) {
  background: linear-gradient(90deg, #fefdfd 0%, #f8fafe 100%) !important;
  border: none;
  box-shadow: none;
}

/* 子菜单项样式调整 */
.console-menu :deep(.el-sub-menu .el-menu-item) {
  height: 40px;
  line-height: 40px;
  padding-left: 56px !important;
  background: transparent;
  color: #606266;
  font-size: 13px;
}

.console-menu :deep(.el-sub-menu .el-menu-item:hover) {
  background-color: #d4cfcf;
  color: #303133;
}

.console-menu :deep(.el-sub-menu .el-menu-item.is-active) {
  background-color: #ecf5ff;
  color: #409eff;
  border-right: 3px solid #409eff;
}

/* 子菜单箭头图标 */
.console-menu :deep(.el-sub-menu .el-sub-menu__title .el-sub-menu__icon-arrow) {
  color: #272829 !important;
  font-size: 14px !important;
  font-weight: bold !important;
  transition: transform 0.3s !important;
  margin-right: 8px !important;
}

/* 确保在激活和打开状态下箭头图标仍然保持灰色 */
.console-menu :deep(.el-sub-menu.is-active .el-sub-menu__title .el-sub-menu__icon-arrow),
.console-menu :deep(.el-sub-menu.is-opened .el-sub-menu__title .el-sub-menu__icon-arrow) {
  color: #272829 !important;
}

.console-menu :deep(.el-sub-menu.is-opened .el-sub-menu__title .el-sub-menu__icon-arrow) {
  transform: rotate(180deg) !important;
}

/* 选中子菜单时系统管理菜单激活状态 - 只改变Tools图标颜色 */
.console-menu :deep(.el-sub-menu.is-active > .el-sub-menu__title .custom_icon) {
  color: #409eff !important;
}

.console-main-container {
  flex-direction: column;
  background-color: #f5f7fa;
  padding: 0;
  margin: 0;
  overflow: auto;
}

.console-main {
  padding: 0;
  margin: 0;
  height: 100%;
  box-sizing: border-box;
  background-color: #f5f7fa;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.main-content {
  flex: 1;

  overflow: auto;



}

/* 响应式设计 */
@media (max-width: 992px) {
  .console-sidebar {
    width: 200px !important;
  }

  .main-content {
    padding: 16px;
    margin: 12px;
  }
}

@media (max-width: 768px) {
  .console-layout {
    flex-direction: column;
  }

  .console-sidebar {
    width: 100% !important;
    height: auto;
    border-right: none;
    border-bottom: 1px solid #eaeef2;
  }

  .console-menu {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 10px;
  }

  .console-menu :deep(.el-menu-item) {
    margin: 4px;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    min-width: auto;
    flex: 1;
    text-align: center;
    border-radius: 20px;
  }

  .console-menu :deep(.el-menu-item) .el-icon {
    margin-right: 0;
    margin-bottom: 4px;
    display: block;
    margin: 0 auto 4px;
  }

  .console-menu :deep(.el-menu-item.is-active) {
    border-right: none;
    border-bottom: 2px solid #409eff;
  }

  .main-content {
    padding: 12px;
    margin: 8px;
  }
}
</style>